import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { profileUrl, raceUrl } from '../../helpers/urlBuilder';

const onClick = (event) => {
    event.stopPropagation();
};


/**
 * Table cell representing Horse Name
 *
 * @param {{}} props
 * @constructor
 */
const HorseNameCell = ({ rowData, customCell: { options: fieldNames } }) => (
    <span>
        {(() => {
            if (!rowData[fieldNames.horseUid]) {
                return rowData[fieldNames.horseName];
            }

            return (
                <a
                    href={profileUrl(
                        'horse',
                        rowData[fieldNames.horseUid],
                        rowData[fieldNames.horseName]
                    )}
                    className="js-popupLink ui-link ui-link_table"
                    onClick={onClick}
                >
                    {rowData[fieldNames.horseName]}
                    <Svg
                        iconName="right"
                        size="XSmall"
                    />
                </a>
            );
        })()}
        {(() => {
            if (!rowData[fieldNames.entered] || !rowData[fieldNames.entryDetails]) {
                return '';
            }
            return (
                <div>
                    <a
                        href={raceUrl(
                            rowData[fieldNames.entryDetails][fieldNames.courseId],
                            rowData[fieldNames.entryDetails][fieldNames.courseName],
                            rowData[fieldNames.entryDetails][fieldNames.raceDate],
                            rowData[fieldNames.entryDetails][fieldNames.raceId],
                        )}
                        className="ui-link ui-btn ui-btn_small ui-btn_secondary sales__entryLabel"
                        onClick={onClick}
                        target="_blank"
                    >
                        ENTRY
                    </a>
                </div>
            );
        })()}
    </span>
);

HorseNameCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default HorseNameCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/HorseNameCell.js